import React, { useEffect, useRef, useState } from "react";
import jsPDF from "jspdf";
import InterRegular from "../../../sale/font/Inter_24pt-Regular-normal";
import InterBold from "../../../sale/font/Inter_24pt-Bold-normal";
import uRLs from "../../../../../utils/baseUtils";
import { usePermission } from "../../../../../context/PermissionContext";
import QRCode from "qrcode";

import { capitalizeFirstLetter } from "../../../../../templates/modules/invoiceUtils";
import { useAuth } from "../../../../../context/AuthProvider";
const HalfA4_5 = ({
  isViewData,
  selectedTheme,
  selectedSize,
  invoiceConfig,
  optData,
}) => {
  const { storeSettings } = usePermission();
   const { settings } = useAuth();
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState("");
  const [data, setData] = useState({});

  const { documentConfig } = invoiceConfig;

  useEffect(() => {
    setData(isViewData);
  }, [isViewData]);

  useEffect(() => {
    jsPDF.API.events.push([
      "addFonts",
      function () {
        this.addFileToVFS("Inter_24pt-Regular-normal.ttf", InterRegular);
        this.addFileToVFS("Inter_24pt-Bold-normal.ttf", InterBold);
        this.addFont(
          "Inter_24pt-Regular-normal.ttf",
          "Inter-Regular",
          "normal",
        );
        this.addFont("Inter_24pt-Bold-normal.ttf", "Inter-Bold", "bold");
      },
    ]);
  }, []);

  useEffect(() => {
    const upi = storeSettings?.paymentSettings?.upiId;

    const name = storeSettings?.paymentSettings?.bankDetails?.beneficiaryName;
    if (!upi) return; // skip until upi is available

    const upiUrl = `upi://pay?pa=${upi}&pn=${encodeURIComponent(name)}&cu=INR`;
    console.log("ip", upiUrl);
    QRCode.toDataURL(upiUrl)
      .then((url) => {
        setQrCodeDataUrl(url);
      })
      .catch((err) => {
        console.error("QR Code generation failed: ", err);
      });
  }, [
    storeSettings?.paymentSettings?.upiId,
    storeSettings?.paymentSettings?.bankDetails?.beneficiaryName,
  ]);

  return (
    <>
      <div className="invoice-scale">
        {selectedSize === "INVOICE" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1">
                <div className="tm_invoice_in" style={{ padding: "20px" }}>
                  <div className="tm_invoice_in p-2">
                    <table width="100%" className="pdfcontent">
                      <tbody>
                        <tr>
                          <td width="60%" style={{ textAlign: "left" }}>
                            <div className="d-flex gap-3 align-items-start">
                              <div className="tm_logo">
 {("/assets/images/logo-light.png" ||
                                settings?.saleProfileData?.image) && (
                                <img
                                  src={
                                    settings?.saleProfileData?.image
                                      ? uRLs.IMAGE_URL +
                                        "profile/" +
                                        settings?.saleProfileData?.image
                                      : "/assets/images/logo-light.png"
                                  }
                                  className="img-rounded logo mb-0"
                                  height="30"
                                />
                              )}
                              </div>
                              <div
                                style={{ fontSize: "13px", lineHeight: "16px" }}
                              >
                                <div style={{ fontWeight: "600" }}>
                                  {documentConfig?.fromData?.title || ""}{" "}
                                </div>
                                <div className="font-12">
                                  {documentConfig?.fromData?.addressline1}{" "}
                                  {documentConfig?.fromData?.addressline2}{" "}
                                  {documentConfig?.fromData?.pincode || ""}
                                </div>

                                <div className="font-12">
                                  <span className="fw-bold">Ph:</span>{" "}
                                  {documentConfig?.fromData?.phone || ""}
                                  {documentConfig?.fromData
                                    ?.additionalPhone && (
                                    <>
                                      ,{" "}
                                      {documentConfig.fromData.additionalPhone}
                                    </>
                                  )}{" "}
                                </div>
                                {documentConfig?.fromData?.gstnumber && (
                                  <div>
                                    <span className="fw-bold">GSTIN:</span>{" "}
                                    {documentConfig?.fromData?.gstnumber}
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td width="40%" style={{ textAlign: "right" }}>
                            <div className="tm_primary_color tm_f50 tm_text_uppercase font-14 fw-bold">
                              {documentConfig?.title && (
                                <>{documentConfig.title}</>
                              )}
                            </div>
                            {data?.status === "CANCELLED" && (
                              <span className="badge rounded-pill bg-label-danger mt-3 font-14 tm_text_uppercase">
                                {data?.status}
                              </span>
                            )}
                            <div style={{ flex: "1", textAlign: "right" }}>
                              <div
                                className="mt-1"
                                style={{
                                  display: "inline-block",
                                  textAlign: "right",
                                }}
                              >
                                <div
                                  className=" font-12"
                                  style={{
                                    borderBottom: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                    marginBottom: "5px",
                                  }}
                                >
                                  {documentConfig?.numberLabel}
                                  <span className="fw-bold">
                                    {" "}
                                    {documentConfig?.number}
                                  </span>
                                </div>
                                <div className="d-flex justify-content-end font-12">
                                  <span>
                                    {" "}
                                    DATE: {documentConfig?.Date?.date}
                                  </span>
                                  <span className="ms-3">
                                    TIME:{documentConfig?.Date?.time}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  {documentConfig?.toData && optData?.isCustomerDisplay && (
                    <div
                      className="d-flex mt-1"
                      style={{
                        border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                      }}
                    >
                      <div
                        style={{
                          flex: "1",
                          padding: "5px",
                          borderRight: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                        }}
                      >
                        <span className="fw-bold font-13">
                          To :{" "}
                          <span className="font-14 ">
                            {documentConfig?.toData?.name}
                          </span>
                        </span>

                        <div className="font-10">
                          {" "}
                          {documentConfig?.toData?.addressline1 &&
                            `${documentConfig?.toData?.addressline1}, `}
                          {documentConfig?.toData?.addressline2 &&
                            `${documentConfig?.toData?.addressline2}, `}
                          {documentConfig?.toData?.district &&
                            `${documentConfig?.toData?.district}, `}
                          {documentConfig?.toData?.pincode &&
                            ` - ${documentConfig?.toData?.pincode}`}
                        </div>
                        <div className="font-10">
                          {[
                            documentConfig?.toData?.gstnumber &&
                              `GSTIN: ${documentConfig?.toData.gstnumber}`,
                            documentConfig?.toData?.phone &&
                              `Mobile: ${documentConfig?.toData.phone}`,
                            documentConfig?.toData?.referenceid &&
                              `Reference No: ${documentConfig?.toData.referenceid}`,
                            documentConfig?.toData?.fssai &&
                              `FSSAI: ${documentConfig?.toData.fssai}`,
                            documentConfig?.toData?.cinnumber &&
                              `CIN: ${documentConfig?.toData.cinnumber}`,
                            documentConfig?.toData?.pannumber &&
                              `PAN: ${documentConfig?.toData.pannumber}`,
                          ]
                            .filter(Boolean)
                            .map((item, index, arr) => (
                              <React.Fragment key={index}>
                                <span>{item}</span>
                                {index < arr.length - 1 && (
                                  <span style={{ margin: "0 5px" }}>|</span>
                                )}
                              </React.Fragment>
                            ))}
                        </div>
                      </div>
                    </div>
                  )}
                  <table
                    // className="items"
                    width="100%"
                    style={{
                      borderCollapse: "collapse",
                    }}
                    cellPadding="4"
                  >
                    <thead className="font-11">
                      <tr>
                        <th
                          className="force-style"
                          style={{
                            width: "20px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          S.No
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "240px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Description
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "120px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          HSN/SAC
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "50px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          MRP
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Base Price
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Qty
                        </th>

                        <th
                          className="force-style"
                          style={{
                            width: "30px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Tax Val
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Tax
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Tax Amt
                        </th>
                        <th
                          className="force-style"
                          style={{
                            width: "100px",
                            textAlign: "center",
                            "--th-bg":
                              selectedTheme?.templateTheme?.primaryColor,
                            "--th-color":
                              selectedTheme?.templateTheme?.foregroundColor,
                            "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                          }}
                        >
                          Amount
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {documentConfig?.items?.map((product, index) => (
                        <tr key={index} className="font-11">
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "left",
                              fontSize: "11px",
                              width: "30%",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            <div>{product?.title}</div>
                            {/* {product?.imode === "SERVICE" && (
                                               <div className="ms-0 fsz-10 lh-13 mb-1">
                                                 {product?.description}
                                               </div>
                                             )} */}
                            {product.imode === "PRODUCT" && product.note && (
                              <div className="ms-0 fsz-10 mb-1">
                                {product?.note}
                              </div>
                            )}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.hsnsac}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.mrp}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.baseprice}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.quantity}
                            <span className="font-11 ms-1">
                              {(() => {
                                const unitCode = product?.isSecondaryUnit
                                  ? product?.unitConfig?.secondaryUnitCode
                                  : product?.unitConfig?.primaryUnitCode;

                                // return unitCode !== "unit" ? unitCode : "";
                                return unitCode || "";
                              })()}
                            </span>
                          </td>

                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.lineTotalBasePrice}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {`${product?.taxpercentage}%`}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.lineTotalTaxAmount}
                          </td>
                          <td
                            className="force-style"
                            style={{
                              textAlign: "center",
                              fontSize: "11px",
                              "--td-border": `0.5mm solid ${selectedTheme?.templateTheme?.borderColor} `,
                            }}
                          >
                            {product?.lineGrandTotal}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    <tfoot>
                      <tr className="font-11">
                        <td
                          colSpan="7"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "left",
                            padding: "6px",
                          }}
                        >
                          <span className="fw-bold">Rupees in words:</span>{" "}
                          {documentConfig?.amountInWords}
                        </td>
                        <td
                          className="font-11"
                          colSpan="3"
                          style={{
                            border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                            textAlign: "right",
                            padding: "6px",
                            fontWeight: "bold",
                          }}
                        >
                          TOTAL AMOUNT :{" "}
                          <span className="ms-2 font-11">
                            {" "}
                            {documentConfig?.grandTotal}
                          </span>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                  {optData?.isRemark && documentConfig?.remarks ? (
                    <>
                      <div className="font-12 mt-2 fw-600 text-black mb-1">
                        Remark
                      </div>

                      <div
                        className="font-12 mb-2 p-0"
                        style={{
                          whiteSpace: "pre-wrap",
                          wordBreak: "break-word",
                        }}
                      >
                        {capitalizeFirstLetter(documentConfig?.remarks)}
                      </div>
                    </>
                  ) : null}
                  <div className="row mt-2 p-2">
                    <div className="col-4 p-2 pt-0  border-dark font-11">
                      {optData?.isBankDetails &&
                        storeSettings?.paymentSettings?.bankDetails && (
                          <>
                            <strong>Bank Details:</strong>
                            {documentConfig?.bankDetails?.accountNo && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>
                                  Account #:
                                </span>
                                {documentConfig?.bankDetails?.accountNo}
                              </div>
                            )}
                            {documentConfig?.bankDetails?.ifsc && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>IFSC:</span>
                                {documentConfig?.bankDetails?.ifsc}
                              </div>
                            )}
                            {documentConfig?.bankDetails?.beneficiaryName && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>Name:</span>
                                {documentConfig?.bankDetails?.beneficiaryName}
                              </div>
                            )}
                            {documentConfig?.bankDetails?.bankName && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>
                                  Bank Name:
                                </span>
                                {documentConfig?.bankDetails?.bankName}
                              </div>
                            )}
                            {documentConfig?.bankDetails?.branch && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>
                                  Branch Name:
                                </span>
                                {documentConfig?.bankDetails?.branch}
                              </div>
                            )}
                            {documentConfig?.upiId && (
                              <div className="d-flex font-11">
                                <span style={{ width: "100px" }}>UPI ID:</span>
                                {documentConfig?.upiId}
                              </div>
                            )}{" "}
                          </>
                        )}
                    </div>
                    {qrCodeDataUrl && optData?.isBankDetails && (
                      <div className="col-3 d-flex align-items-center justify-content-end">
                        <img
                          src={qrCodeDataUrl}
                          alt="QR"
                          style={{ width: "100px", height: "100px" }}
                        />
                      </div>
                    )}

                    <div className="col-5  ms-auto">
                      <div className="text-end p-0 fw-bold font-12 mt-2 ">
                        {documentConfig?.fromData?.title}
                      </div>
                      <div>
                        {storeSettings?.invoiceSettings?.signature ? (
                          <div className="text-end p-0 fw-bold pb-1">
                            <img
                              src={
                                uRLs.IMAGE_URL +
                                storeSettings?.invoiceSettings?.signature
                              }
                              width={100}
                            />
                          </div>
                        ) : (
                          <div className="p-0 pt-4">
                            <hr
                              className="m-1 ms-auto "
                              style={{
                                border: `1px solid ${selectedTheme?.templateTheme?.borderColor}`,
                                maxWidth: "120px",
                              }}
                            />
                          </div>
                        )}
                        <div className="text-end p-0 font-12">
                          Authorized Signatory
                        </div>
                      </div>
                    </div>
                  </div>

                  {storeSettings?.negobillBranding && (
                    <>
                      <div className="mt-5 font-12 d-flex justify-content-end ">
                        <span>
                          Powered By{" "}
                          <span className="fw-bold">NegoBill.com</span>
                        </span>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : selectedSize === "BILL" ? (
          <div className="tm_container">
            <div className="tm_invoice_wrap">
              <div className="tm_invoice tm_style1 tm_type1"></div>
            </div>
          </div>
        ) : (
          <div className="default-content">
            <p>No content available for this sale mode.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default HalfA4_5;
